import { packagePlanActionTypes as actionTypes } from '../../ActionTypes/Voss/packagePlanActionTypes';
import { apiThunk } from '../../Utils/apiThunk';
import { mutatePackageResource, packageResourceUrl } from './packageResourceApi';
import type { AppDispatch } from '../../Store/types';
import type { PackagePlan, PackagePlanRequest } from '../../Components/Voss/Packages/Packages.types';

const PLANS_LOADING_KEY = 'packagePlans';

const planUrl = (packageId: string, versionId: string | undefined, planId?: string) => packageResourceUrl(packageId, 'plans', versionId, planId);

// the plans embedded in GET /api/packages/{id} lack periodEndAnchor, so the tab is fed from the plan endpoint instead
const fetchPlans = (packageId: string, versionId: string | undefined) => (dispatch: AppDispatch) =>
    dispatch(apiThunk<PackagePlan[]>(planUrl(packageId, versionId), { loadingKey: PLANS_LOADING_KEY })).then((data) => {
        if (data !== null) dispatch({ type: actionTypes.STORE_PACKAGE_PLANS, data: { versionId, plans: data } });
    });

// resolves true once the write succeeded and the list is being refreshed, false if it failed (the toast has already been shown)
const changePlan = (packageId: string, versionId: string | undefined, url: string, init: RequestInit) => (dispatch: AppDispatch) =>
    dispatch(mutatePackageResource(url, init)).then((succeeded) => {
        if (succeeded) void dispatch(fetchPlans(packageId, versionId));

        return succeeded;
    });

const packagePlanActions = {
    fetchPlans,

    clearPlans() {
        return { type: actionTypes.CLEAR_PACKAGE_PLANS };
    },

    // the copy picker must not share the tab's loading flag, or its response would hide the tab's spinner
    getPlans(packageId: string, versionId: string | undefined) {
        return apiThunk<PackagePlan[]>(planUrl(packageId, versionId), { loadingKey: 'copyPlanSource' });
    },

    createPlan(packageId: string, model: PackagePlanRequest, versionId: string | undefined) {
        return changePlan(packageId, versionId, planUrl(packageId, versionId), { method: 'POST', body: JSON.stringify(model) });
    },

    updatePlan(packageId: string, planId: string, model: PackagePlanRequest, versionId: string | undefined) {
        return changePlan(packageId, versionId, planUrl(packageId, versionId, planId), { method: 'PUT', body: JSON.stringify(model) });
    },

    deletePlan(packageId: string, planId: string, versionId: string | undefined) {
        return changePlan(packageId, versionId, planUrl(packageId, versionId, planId), { method: 'DELETE' });
    },
};

export default packagePlanActions;
